import React, { useState } from "react";
import "./styles.scss";

import ApplicationFormBosnia from "../components/application-form/bosnia/ApplicationFormBosnia";
import SidePanel from "../components/side-panal/SidePanel";
import { PDFViewer } from "@react-pdf/renderer";
import Preview from "../components/preview/bosnia/Preview";
import ApplicationBosniaModel from "../../../database/models/application-form/bosnia/Application";
import { Country } from "../../../shared/constants/Constant";
import HeaderMobile from "../components/header-mobile/HeaderMobile";

const ApplicationBosnia = () => {
  const [preview, setPreview] = useState(false);
  const initialApplicationMalaysia: ApplicationBosniaModel = {
    fullName: "",
    dob: new Date(),
    email: "",
    contact: "",
    placeOfResidence: "",
    whoYouAre: "Undegraduate student",
    whatYouAreStudying: "",
    cvLink: null,
    commitment: "",
    motivation: "",
    pastExperience: "",
    country: Country.BOSNIA,
  };

  const [data, setData] = useState({
    application: initialApplicationMalaysia,
    fileName: "this is file name",
  });
  return (
    <>
      {!preview ? (
        <div>
          <div className="side-panal">
            <SidePanel country={Country.BOSNIA} />
          </div>
          <div>
            <HeaderMobile country={Country.BOSNIA} />
          </div>
          <div
            className="main-content"
            style={{
              backgroundColor: "rgb(254, 254, 255)",
              minHeight: "100vh",
            }}
          >
            <ApplicationFormBosnia
              onComplete={(completedApplication, fileName) => {
                setData({ application: completedApplication, fileName });
                setPreview(true);
              }}
            />
          </div>
        </div>
      ) : (
        <div className="preview-application">
          <div className="title bosnia">
            Shown below is the information that you submitted. You may print
            this page for your records.
          </div>
          <PDFViewer>
            <Preview data={data} />
          </PDFViewer>
        </div>
      )}
    </>
  );
};

export default ApplicationBosnia;
